import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';

@Injectable()
export class ProcessoCadastroService extends BaseService<any> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public listFilters(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-filters', { headers: this.headers });
  }

  public clonar(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/clone', obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/pre-projeto/processo-cadastro';
  }
}
